import React from 'react';
import { FaExternalLinkAlt, FaCalendar, FaClock } from 'react-icons/fa';
import { blogData } from '../data/blogData';
import './Blog.css';

const Blog = () => {
  return (
    <section id="blog" className="blog">
      <div className="container">
        <h2 className="section-title">Technical Writing</h2>
        <p className="section-subtitle">
          In-depth articles on GenAI, RAG, and vector search technologies
        </p>

        <div className="blog-grid grid grid-2">
          {blogData.map((post, index) => (
            <a
              key={index}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-card card"
            >
              {post.image && (
                <div className="blog-image-wrapper">
                  <img src={post.image} alt={post.title} className="blog-image" />
                </div>
              )}
              <div className="blog-header">
                {post.featured && (
                  <span className="featured-badge">Featured</span>
                )}
                <div className="blog-meta">
                  <span className="blog-date">
                    <FaCalendar /> {post.date}
                  </span>
                  <span className="blog-read-time">
                    <FaClock /> {post.readTime}
                  </span>
                </div>
              </div>

              <h3 className="blog-title">{post.title}</h3>
              <p className="blog-excerpt">{post.excerpt}</p>

              <div className="blog-tags">
                {post.tags.map((tag, i) => (
                  <span key={i} className="blog-tag">{tag}</span>
                ))}
              </div>

              <div className="blog-link-wrapper">
                <span className="blog-link">
                  Read Article <FaExternalLinkAlt />
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* <div className="blog-cta">
          <p>Want to see more of my writing?</p>
          <a 
            href="https://weaviate.io/blog" 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Visit Weaviate Blog
          </a>
        </div> */}
      </div>
    </section>
  );
};

export default Blog;

